// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"99c12c58f36b4be0","6220":"514dce9909348ecd","6417":"bf3b217b7955ee0e","8462":"0394c63d10ab5980","9516":"4b7c58c9a227ef25"}[chunkId] + ".css";
};